import axios from "axios";
import Constants from "../../../components.constants.js";

export default {

    async updateStartUpEntry(context, payload = {}){
        try {
            if(payload != undefined && Object.keys(payload).includes("key")){
                context.rootState.startUpData.startUpDataDetails[payload.key] = payload.content;
                context.commit("updatestartupDatainfo",payload)
            }
        } catch (error) {
            console.error(
                `[updateStartUpEntry][Store][Error occured while updating startupdata List--->${error}]`
            );
            return {}
        }

    },

    async getStartUpDataFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(Constants.startUpDataUrl, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                Object.assign(context.rootState.startUpData.startUpDataDetails,resp.data);
                context.commit("setstartupDatainfo", resp.data)
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
            return resp.data
        } catch (error) {
            console.error(
                `[getStartUpDataFromServer][Store][Error occured while getting startupdata List--->${error}]`
            );
            return {}
        }
    },
};